import { render, staticRenderFns } from "./UserPrivileges.vue?vue&type=template&id=b72f307e&scoped=true"
import script from "./UserPrivileges.vue?vue&type=script&lang=js"
export * from "./UserPrivileges.vue?vue&type=script&lang=js"
import style0 from "./UserPrivileges.vue?vue&type=style&index=0&id=b72f307e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72f307e",
  null
  
)

export default component.exports